
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { createWorker } from 'tesseract.js';
import { CommonUtilty } from '../../utilities';
import { RuleEngineEvaluatorService } from '../../utilities/ruleEngineEvaluator';

@Injectable(
    {
        providedIn: 'root'
    }
)
export class DocumentValidatorService {

  constructor(private ruleEngineEvaluator: RuleEngineEvaluatorService,
    private commonUtility: CommonUtilty) { }

  // the attributes ruleCd and ruleName are specific to OCR verification using tessaract.js POC and is not related to PC Rules  
  OCRDocumentTypesMapper = {
    'AADHAR': [
        {
            ruleCd: 'AADHARNUMBERVALIDATOR',
            ruleName: 'Aadhar Number Check',
            ruleWeight: 20, 
            condition: (data) => {
                if(data){
                    data = data.replaceAll(/[2-9]{1}[0-9]{3}\s{1}[0-9]{4}\s{1}[0-9]{4}/g, 'AADHARMATCHFOUND') 
                    return data.includes('AADHARMATCHFOUND');
                }
            },
            action: (data, rulesOutput: Array<any>, rule) => {
                rulesOutput.push({validationStatus: true, validationMsg: 'AADHAR Number is valid', ruleCd: rule.ruleCd, ruleName: rule.ruleName, weight: rule.ruleWeight})
                return rulesOutput;
            } 
        },
        {
          ruleCd: 'AADHARISSUINGAUTHORITYVALIDATOR',
          ruleName: 'Aadhar Issuing Authority',
          ruleWeight: 20, 
          condition: (data) => data && data.toLowerCase().includes('government') && data.toLowerCase().includes('of') && data.toLowerCase().includes('india') ,
          action: (data, rulesOutput: Array<any>, rule) => {
            rulesOutput.push({validationStatus: true, validationMsg: 'AADHAR Issuing authority is valid', ruleCd: rule.ruleCd, ruleName: rule.ruleName, weight: rule.ruleWeight })
            return rulesOutput;
          } 
        },
      ],
      'PANCARD': [
          {
              ruleCd: 'PANNUMBERVALIDATOR',
              ruleName: 'PAN Number Check',
              ruleWeight: 40,
              condition: (data) => {
                  if (data) {
                      data = data.replaceAll(/([A-Z]){5}([0-9]){4}([A-Z]){1}/g, 'PANCARDMATCHFOUND')
                      return data.includes('PANCARDMATCHFOUND');
                  }
              },
              action: (data, rulesOutput: Array<any>, rule) => {
                  rulesOutput.push({ validationStatus: true, validationMsg: 'PAN Number is valid', ruleCd: rule.ruleCd, ruleName: rule.ruleName, weight: rule.ruleWeight })
                  return rulesOutput;
              }
          },
          {
              ruleCd: 'PANISSUINGAUTHORITYVALIDATOR',
              ruleName: 'Pan Issuing Authority',
              ruleWeight: 40,
              condition: (data) => data && data.toLowerCase().includes('income') && data.toLowerCase().includes('tax') && data.toLowerCase().includes('department'),
              action: (data, rulesOutput: Array<any>, rule) => {
                  rulesOutput.push({ validationStatus: true, validationMsg: 'PAN Issuing authority is valid', ruleCd: rule.ruleCd, ruleName: rule.ruleName, weight: rule.ruleWeight })
                  return rulesOutput;
              }
          },
      ],
      'PASSPORT': [
        {
            ruleCd: 'PASSPORTNUMBERVALIDATOR',
            ruleName: 'Passport Number',
            ruleWeight: 40,
            condition: (data) => {
                if (data) {
                    data = data.replaceAll(/[A-PR-WY][1-9]\d\s?\d{4}[1-9]/g, 'PASSPORTMATCHFOUND')
                    return data.includes('PASSPORTMATCHFOUND');
                }
            },
            action: (data, rulesOutput: Array<any>, rule) => {
                rulesOutput.push({ validationStatus: true, validationMsg: 'Passport Number is valid', ruleCd: rule.ruleCd, ruleName: rule.ruleName, weight: rule.ruleWeight })
                return rulesOutput;
            }
        },
        {
            ruleCd: 'PASSPORTISSUINGAUTHORITYVALIDATOR',
            ruleName: 'Passport Issuing Authority',
            ruleWeight: 40,
            condition: (data) => data && data.toLowerCase().includes('republic') && data.toLowerCase().includes('of') && data.toLowerCase().includes('india'),
            action: (data, rulesOutput: Array<any>, rule) => {
                rulesOutput.push({ validationStatus: true, validationMsg: 'Passport Issuing authority is valid', ruleCd: rule.ruleCd, ruleName: rule.ruleName, weight: rule.ruleWeight })
                return rulesOutput;
            }
        }
    ],
  }

//   threshold default value is 80%
    rulePassThreshold = 80;
    validateDocument(blobImg, documentId, documentData?): Observable<any> {
        let ocrOutputSubject: Subject<any> = new Subject();
         this.doOCR(blobImg).then(ele => {
            let result = this.ruleEngineEvaluator.evaluateRules(this.OCRDocumentTypesMapper[documentId], ele, []);
            let validRuleOutput = result.reduce((acc, item)=>{
                if(item.validationStatus) {
                    acc += item.weight;
                }
                return acc
            }, 0)

            let sumOfConditions = result.reduce((acc, item)=> {
                 acc += item.weight ? item.weight : 0
                 return acc;
            }, 0)
            let validityScore = validRuleOutput / sumOfConditions * 100
            let finalOutput = { validityScore: validityScore, finalStatus: `${validityScore > this.rulePassThreshold ? 'Pass' : 'Fail' }`, documentId }
            console.log('document result',result);
            console.log('document final result',finalOutput);
            let documentVerification = { data: result, status: finalOutput,  }
            ocrOutputSubject.next(documentVerification)
            // return finalOutput;
        })
        return ocrOutputSubject;
    } 

  async doOCR(blobImg): Promise<any> {
    // let validatorSubject: Subject<any> = new Subject();
    const worker = await createWorker({
      logger: m => console.log(m),
    });
    await worker.load();
    await worker.loadLanguage('eng');
    await worker.initialize('eng');
    const { data: { text } } = await worker.recognize(blobImg);
    console.log('ocr result',text);
    // validatorSubject.next(text);
    await worker.terminate();
    return text;
  }

}
